import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/viewcombineproductmasterForm';
import Table from '../../Tables/DataTable/components/DataTable';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const ViewCombineProductMasterForm = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">COMBINED PRODUCT MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewCombineProductMasterForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewCombineProductMasterForm);
